import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {authenticationChildGuard, authenticationGuard} from "./_guards/authentication.guard";
import {verifyGuard} from "./_guards/verify.guard";
import {LoginComponent} from "./_public/login/login.component";

const routes: Routes = [
  {
    path: 'msft',
    component: LoginComponent,
    data: {
      autoSsoProvider: "microsoft"
    }
  },
  {
    path: 'google',
    component: LoginComponent,
    data: {
      autoSsoProvider: "google"
    }
  },
  {
    path: 'login',
    loadChildren: () => import('./_public/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'password',
    loadChildren: () => import('./_public/password/password.module').then(m => m.PasswordModule)
  },
  {
    path: 'verify-code',
    canActivate: [verifyGuard],
    loadChildren: () => import('./_public/verify-code/verify-code.module').then(m => m.VerifyCodeModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./_public/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'print',
    canActivate: [authenticationGuard],
    loadChildren: () => import("./_secure/legal/legal-document-print/legal-document-print.module").then(m => m.LegalDocumentPrintModule)
  },
  {
    path: 'secure',
    canActivate: [authenticationGuard],
    canActivateChild: [authenticationChildGuard],
    loadChildren: () => import('./_secure/secure.module').then(m => m.SecureModule)
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "secure",
  },
  {
    path: "**",
    pathMatch: "full",
    redirectTo: "secure",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
